import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { GrowthTrajectoryDto } from '../../../models/analytics/dto/get-growth-trajectory.dto';

export const GET_GROWTH_TRAJECTORY_QUERY_KEY = 'growthTrajectory';

export const useGetGrowthTrajectory = (locationId: string | undefined) => {
    const apiClient = useApiClient();
    return useQuery<GrowthTrajectoryDto>({
        queryKey: [GET_GROWTH_TRAJECTORY_QUERY_KEY, locationId],
        queryFn: async () => {
            return apiClient.fetchApi<GrowthTrajectoryDto, {}>({
                method: 'GET',
                endpoint: `analytics/growth-trajectory?locationId=${locationId}`,
            });
        },
        enabled: !!locationId,
        staleTime: 5 * 60 * 1000,
    });
};
